<template>
  <div>
    <v-select
      v-model="currentCountry"
      :items="serviceAllowCountries"
      solo
      hide-details
      item-value="id"
      item-text="name"
      label="Country"
      flat
      return-object
      class="caption"
    >
      <template v-slot:item="{ item }">
        <flag
          v-if="item.code"
          :iso="item.code"
          class="mr-2"
          :squared="false"
        />
        {{ item.name }}
      </template>
      <template v-slot:selection="{ item }">
        <flag
          v-if="item.code"
          :iso="item.code"
          class="mr-2"
          :squared="false"
        />
        {{ item.name }}
      </template>
    </v-select>
    <v-select
      v-model="currentBase"
      :items="serviceAllowBases"
      solo
      hide-details
      item-value="id"
      item-text="name"
      label="Base"
      flat
      return-object
      class="caption"
    />
  </div>
</template>
<script>
  import ability from '@/plugins/ability'
  import { cloneDeep } from 'lodash'

  export default {
    name: 'CurrentLocationSelect',
    computed: {
      serviceAllowCountries() {
        if (!this.$store.state.auth.authenticated || !this.$store.state.auth.user) return []

        let allowCountries = cloneDeep(this.$store.state.auth.user.service_allow_countries)

        if (ability.can('service-allow-all-countries', null)) {
          allowCountries.unshift({ id: null, name: 'All Countries' })
        }

        return allowCountries
      },
      serviceAllowBases() {
        if (!this.$store.state.auth.authenticated || !this.$store.state.auth.user || !this.currentCountry) return []

        let allowBases = cloneDeep(this.$store.state.auth.user.service_allow_bases.filter(b => b.country_id === this.currentCountry.id))

        if (ability.can('service-allow-all-bases', null)) {
          allowBases.unshift({ id: null, name: 'All Bases' })
        }

        return allowBases
      },
      currentCountry: {
        get: function () {
          return this.$store.state.service.currentLocation.country || { id: null, name: 'All Countries' }
        },
        set: function (country) {
          this.$store.dispatch('service/setCurrentCountry', (country && country.id) ? country : null)
        }
      },
      currentBase: {
        get: function () {
          return this.$store.state.service.currentLocation.base || { id: null, name: 'All Bases' }
        },
        set: function (base) {
          this.$store.dispatch('service/setCurrentBase', (base && base.id) ? base : null)
        }
      }
    }
  }
</script>
